var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.484,
    height: 24.085,
    viewBox: "0 0 20.484 24.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    transform: "translate(-4.847 -0.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-6504.648-7976.883h-20.484v-3.938a10.251,10.251,0,0,1,5.3-8.975,6.981,6.981,0,0,0,4.718,1.83,6.962,6.962,0,0,0,4.878-1.979,10.206,10.206,0,0,1,5.585,9.125v3.938Z",
    transform: "translate(6529.979 8001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M13.895,8.12l.945-.334a4.509,4.509,0,0,0,.974,1.137l-.457.955,2.051.98.456-.955a4.522,4.522,0,0,0,1.465.048l.347.984,1.714-.606-.343-.968a4.5,4.5,0,0,0,1.169-1l.954.456.978-2.044-.955-.457a4.518,4.518,0,0,0,.046-1.5l.945-.333-.605-1.714-.945.333a4.513,4.513,0,0,0-.97-1.134l.457-.956L20.06.032,19.6.989a4.522,4.522,0,0,0-1.524-.04l-.32-.908L16.043.646l.326.923a4.488,4.488,0,0,0-1.107.952l-.956-.457-.984,2.058.956.457a4.5,4.5,0,0,0-.044,1.493l-.945.333Zm4.842-4.259a1.526,1.526,0,1,1-1.526,1.526A1.526,1.526,0,0,1,18.737,3.861Z",
    transform: "translate(-3.648)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.6b2fc8c365addf5e1f3b12772f48d6ad.svg";
export { ForwardRef as ReactComponent };